import React from "react";
import { toElementProps } from "../../Element";

export function BlockOffersStyles(params = {}) {
    return {
        "& .block-offers": {
            display: "grid",
            justifyContent: "center",
        },
    };
}

export default function BlockOffers(props) {
    const elProps = toElementProps(props, { className: ["block-offers"] });
    return <div {...elProps}>{props.children}</div>;
}
